export const PAGE_LIMIT = 30;


// WEBPACK FOOTER //
// ./src/scenes/BidderSpy/config.js